import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Cancel.css';

// Component
import Loader from '../../components/Loader';
import NotFound from '../notFound/NotFound';
import Cancellation from '../../components/Cancellation';

// Graphql
import { CancelQuery } from '../../lib/graphql';
import { withQuery } from '../../hoc/withGraphql';

function Cancel(props) {

	const { cancellationData: { loading, cancelReservationData }, userType } = props;
	if (loading) {
		return (
			<div className={s.space4}>
				<Loader type="text" />
			</div>
		);
	}
	if (cancelReservationData === null || cancelReservationData === undefined) {
		return <NotFound />;
	}
	return (
		<div className={s.root}>
			<div className={s.container}>
				<Cancellation userType={userType} data={cancelReservationData} />
			</div>
		</div>
	);
}

Cancel.propTypes = {
	reservationId: PropTypes.number.isRequired,
	userType: PropTypes.string.isRequired,
	cancellationData: PropTypes.shape({
		loading: PropTypes.bool,
		cancelReservationData: PropTypes.object
	}).isRequired
};
Cancel.defaultProps = {
	cancellationData: {
		loading: true
	}
};

export default compose(
	withStyles(s),
	withQuery(CancelQuery,
		{
			name: 'cancellationData',
			options: (props) => (
				{
					variables: {
						reservationId: Number(props.reservationId),
						userType: props.userType
					},
					fetchPolicy: 'network-only',
					ssr: false
				})
		}
	),
)(Cancel);